import { Outlet } from "react-router-dom";

import { Chat } from "@app/features/chat/Chat";
import { useChatAvailable } from "@app/features/chat/ChatProvider";

import useScrollDirection from "../lib/hooks/useScrollDirection";
import { useUser } from "../lib/hooks/useUser";

import { LoadingOverlay } from "./LoadingOverlay";
import { UIAppState } from "./UIAppState/UIAppState";

export const LearnLayout: React.FC = () => {
  const user = useUser();
  const scrollDirection = useScrollDirection();
  const chatAvailable = useChatAvailable();

  if (user.user == null) return <LoadingOverlay />;

  return (
    <>
      <div data-scroll-direction={scrollDirection}>
        <Outlet />
      </div>
      {chatAvailable && <Chat />}
      <UIAppState />
    </>
  );
};
